import React from 'react'
import betterspaceLogo from '@wellbeingxltd/fe-lib/images/dist/logo/betterspaceWordmarkColour.svg'
import './styles.scss'

function Toolbar({ buttonTitle, onButtonClicked }) {
    return (
        <div className="landing-toolbar">
            <img className="landing-toolbar-logo" src={betterspaceLogo} />
            <div onClick={onButtonClicked} className="landing-toolbar-button">
                {buttonTitle}
            </div>
        </div>
    )
}

export default Toolbar
